import {
  FormLabel
} from "./chunk-7F2CZQJ4.js";
import {
  useFormField
} from "./chunk-MJ3U6SP3.js";
import {
  FontAwesomeIcon
} from "./chunk-APS5QAFW.js";
import {
  cn,
  twVariants
} from "./chunk-LJ5F4WFH.js";

// src/Checkbox/Checkbox.tsx
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import * as React from "react";
var checkboxStyles = twVariants({
  slots: {
    root: [
      "translation-all peer h-4 w-4 shrink-0 rounded-sm border-[1.5px] border-neutral-action-enabled bg-transparent",
      "data-[state=checked]:border-brand-secondary-enabled data-[state=checked]:bg-brand-primary-enabled data-[state=checked]:text-neutral-inversed",
      "data-[state=indeterminate]:border-brand-secondary-enabled data-[state=indeterminate]:bg-brand-primary-enabled data-[state=indeterminate]:text-neutral-inversed",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-radiant-blue focus-visible:ring-offset-2",
      "disabled:cursor-not-allowed disabled:border-brand-secondary-disabled",
      "disabled:data-[state=checked]:border-brand-secondary-disabled disabled:data-[state=checked]:bg-brand-primary-disabled",
      "disabled:data-[state=indeterminate]:border-brand-secondary-disabled disabled:data-[state=indeterminate]:bg-brand-primary-disabled"
    ],
    indicator: "text-current flex items-center justify-center"
  },
  variants: {
    invalid: {
      true: {
        root: "data-[state=checked]:bg-error-enable border-alert-danger data-[state=checked]:border-alert-danger"
      }
    }
  }
});
var Checkbox = React.forwardRef(
  ({
    className,
    defaultChecked,
    checked,
    children,
    labelProps,
    labelPlacement = "end",
    ...props
  }, ref) => {
    const ownProps = useFormField(props);
    const isInvalid = !!ownProps["aria-invalid"];
    const { root, indicator } = checkboxStyles({ invalid: isInvalid });
    const Comp = /* @__PURE__ */ React.createElement(
      CheckboxPrimitive.Root,
      {
        ref,
        className: cn(root(), className),
        defaultChecked,
        checked,
        ...ownProps
      },
      /* @__PURE__ */ React.createElement(CheckboxPrimitive.Indicator, { className: indicator() }, /* @__PURE__ */ React.createElement(
        FontAwesomeIcon,
        {
          name: checked === "indeterminate" ? "minus:regular" : "check:regular",
          className: "h-3 w-3"
        }
      ))
    );
    if (children) {
      return /* @__PURE__ */ React.createElement("span", { className: "inline-flex items-center" }, labelPlacement === "start" && /* @__PURE__ */ React.createElement(FormLabel, { className: "pr-2 text-body-1", ...labelProps }, children), Comp, labelPlacement === "end" && /* @__PURE__ */ React.createElement(FormLabel, { className: "pl-2 text-body-1", ...labelProps }, children));
    }
    return Comp;
  }
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export {
  checkboxStyles,
  Checkbox
};
//# sourceMappingURL=chunk-SDBXCG3Y.js.map